<template>
  <div class="margin-1 pega-table-sp">
    <h6>■マッチング設定</h6>
    <job-content-table title="個人プロフィール">
      <job-content-table-outline
        title="性別"
        :value="matching.gender"
      />
      <job-content-table-outline
        title="年齢"
        :value="age"
      />
      <job-content-table-outline
        title="現住所"
        :value="address"
      />
      <job-content-table-outline
        title="最終学歴"
        :value="educationalBackground"
      />
      <job-content-table-outline
        title="卒業年月"
        :value="graduate"
      />
      <job-content-table-outline
        title="学校名・学部名"
        data-test="educationSearch"
      >
        <template #body>
          <span>「学校名」「学部／学科名」から、フリーワード検索をおこないます。（200文字以内）</span><br>
          <span
            class="pega-break"
            v-text="matching.educationalSearchWord || '未登録'"
          /><br>
          <span
            class="pega-break"
            v-text=" matching.educationSearchLabel || '未登録' "
          />
        </template>
      </job-content-table-outline>
      <job-content-table-outline
        title="学部・学科コード"
        :value="educationDepartment"
      />
      <job-content-table-outline-sub
        title="現在の就業状況"
        :contents="work"
      />
      <job-content-table-outline
        title="転居を伴う転職可否"
        :value="matching.homeMoving"
      />
      <job-content-table-outline
        title="未既婚"
        :value="matching.married"
      />
      <job-content-table-outline
        title="子供有無"
        :value="matching.child"
      />
      <job-content-table-outline
        title="転職回数"
        :value="matching.changeJobCount"
      />
    </job-content-table>

    <job-content-table title="経験職種・業種">
      <job-content-table-outline-sub
        title="経験職種"
        :contents="matching.experiencedOccupationList"
      />
      <job-content-table-outline
        title="経験業種"
        :value="experiencedBusiness"
      />
    </job-content-table>

    <job-content-table title="語学力">
      <job-content-table-outline
        title="TOEIC"
        :value="toeic"
      />
      <job-content-table-outline
        title="TOEFL"
        :value="toefl"
      />
      <job-content-table-outline
        title="英語スキル"
        :value="matching.englishSkill.level"
      />
      <job-content-table-outline
        title="英語以外の語学スキル"
        :value="otherLanguage"
      />
    </job-content-table>

    <job-content-table title="スキルシート・資格">
      <template v-for="skillMaster in skillsMaster">
        <template v-if="hasChildCategorySkillBy(skillMaster.id)">
          <job-content-table-outline-sub
            :key="skillMaster.id"
            :title="skillMaster.name"
            :contents="skill[skillMaster.id]"
          />
        </template>
        <template v-else>
          <job-content-table-outline
            :key="skillMaster.id"
            :title="skillMaster.name"
            :value="skill[skillMaster.id]"
          />
        </template>
      </template>
    </job-content-table>

    <job-content-table title="保有資格">
      <job-content-table-outline
        title="保有資格"
        :value="license"
      />
    </job-content-table>

    <job-content-table title="志向の指定">
      <job-content-table-outline
        v-for="(workStyle,i) in matching.workStyleList"
        :key="`work-style-${i}`"
        :title="workStyle.name"
        :value="createJoinedText(workStyle.labelList)"
      />
    </job-content-table>

    <job-content-table title="希望の指定">
      <job-content-table-outline-sub
        title="希望職種"
        :contents="occupations"
      />
      <job-content-table-outline
        title="希望業種"
        :value="createJoinedText(matching.desiredBusinessNameList)"
      />
      <job-content-table-outline
        title="希望勤務地"
        :value="createJoinedText(matching.desiredWorkPlaceList)"
      />
      <job-content-table-outline
        title="希望雇用形態"
        :value="createJoinedText(matching.desiredEmploymentList)"
      />
    </job-content-table>

    <job-content-table title="フリーワード">
      <job-content-table-outline
        title="フリーワード"
        data-test="freeWord"
      >
        <template #body>
          <span>
            「職務経歴内容」「保有資格」「その他の外国語」「自己PR」から、フリーワード検索をおこないます。（全角200文字以内）<br>
            ※上記項目に登録がない会員は検索対象外となります。また、他の設定条件との掛け合わせでキーワードによってはマッチング条件が厳しくなりすぎる恐れがあります。<br>
            キーワード（スペース区切り）:<br>
          </span>
          <span
            class="pega-break"
            v-text="matching.freeWord || '未登録'"
          /><br>
          <span
            class="pega-break"
            v-text=" matching.freeWordSearchLabel || '未登録' "
          />
        </template>
      </job-content-table-outline>
    </job-content-table>

    <job-content-table title="活動履歴の指定">
      <job-content-table-outline
        title="新規会員の指定"
        :value="matching.registrationDate"
      >
        <br>
        <span>※検索する求職者（女の転職type会員）の対象範囲を指定してください。</span>
      </job-content-table-outline>
    </job-content-table>
  </div>
</template>

<script>
import JobContentTable from '@/components/atoms/JobContentTable'
import JobContentTableOutline from '@/components/atoms/JobContentTableOutline'
import JobContentTableOutlineSub from '@/components/molecules/JobContentTableOutlineSub'
import jobPreviewCommon from '@/lib/jobPreviewCommon'
import jobMatchingCommon from '@/lib/jobMatchingCommon'

export default {
  components: {
    JobContentTable,
    JobContentTableOutline,
    JobContentTableOutlineSub
  },
  mixins: [jobPreviewCommon, jobMatchingCommon],
  props: {
    matching: {
      type: Object,
      required: true
    }
  }
}
</script>
